module.exports = __webpack_public_path__ + "media/react/assets/Comment1-be84096a15311855255ebcb1eb4a24c6.svg";